import { IconButton } from '@src/shared/ui/Button';
import type { ExtendedIconButtonProps } from '@src/shared/ui/Button/IconButton';
import { forwardRef } from 'react';

const NavIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { children, ...rest } = props;
    return (
      <IconButton color="secondary" ref={ref} {...rest}>
        {children}
      </IconButton>
    );
  },
);

export default NavIconButton;
